/**
 * KeyMapAction enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file KeyMapAction.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum KeyMapAction {

  MoveForward = "action200",
  MoveBack = "action201",
  StrafeLeft = "action202",
  StrafeRight = "action203",
  SelectPrev = "action204",
  SelectNext = "action205",
  ChangeChar = "action206",
  PartyActive = "action207",
  Freelook = "action208",
  Equip = "action209",
  Inventory = "action210",
  Character = "action211",
  SkillsAndFeats = "action212",
  Messages = "action213",
  Quests = "action214",
  Map = "action215",
  Options = "action216",
  MGshoot = "action217",
  Quicksave = "action218",
  LeftLookabout = "action219",
  RightLookabout = "action220",
  AlternateActions = "action221",
  AlternateActions2 = "action222",
  GUI = "action223",
  Pause = "action224",
  ToolTips = "action225",
  TargetLeftAct = "action226",
  DEFAULTChg = "action227",
  TargetMiddleAct = "action228",
  FEATSSKILLChg = "action229",
  TargetRightAct = "action230",
  HOSTILEPOWERChg = "action231",
  PersonalPowerAct = "action232",
  HOSTILEITEMChg = "action233",
  PersonalMedicalAct = "action234",
  FRIENDLYPOWERChg = "action235",
  PersonalMinesAct = "action236",
  minesMenuChg = "action237",
  PersonalOtherAct = "action238",
  DefaultAction = "action239",
  CancleCombat = "action240",
  Pause1 = "action241",
  Flourish = "action242",
  PrevMenu = "action243",
  NextMenu = "action244",
  ClearOneAction = "action245",
  ActionMenuLeft = "action246",
  ActionMenuRight = "action247",
  ActionMenuUp = "action248",
  ActionMenuDown = "action249",
  ActionMenuQueue = "action250",
  ActionMenuRemoveQ = "action251",
  ActionMenuShowMenu = "action252",
  PauseMinigame = "action253",
  Dialog1 = "action254",
  Dialog2 = "action255",
  Dialog3 = "action256",
  Dialog4 = "action257",
  Dialog5 = "action258",
  Dialog6 = "action259",
  Dialog7 = "action260",
  Dialog8 = "action261",
  Dialog9 = "action262",
  QUICKLOAD = "action263",
  STEALTH = "action264",
  SwitchWeaps = "action265",  //TSL
  WALKMODIFY = "action268",   //TSL
  ActionUp = "action280a",
  ActionDown = "action280b",
  ActionLeft = "action281a",
  ActionRight = "action281b",
  MGActionUp = "action282a",
  MGActionDown = "action282b",
  MGActionLeft = "action283a",
  MGActionRight = "action283b",
  CameraRotateLeft = "action284a",
  CameraRotateRight = "action284b",
  ArrowUp = "action285a",
  ArrowDown = "action285b",
  ArrowLeft = "action286a",
  ArrowRight = "action286b",

  DialogSkip = "action900",
  DialogAbort = "action901",

  FlyUp = "action1001",
  FlyDown = "action1002",
  ResolutionScaleUp = "action1003",
  ResolutionScaleDown = "action1004",
  ResolutionScaleReset = "action1004",
  MovieSkip = "action901m",

}